import React, { FC } from 'react';

type HiddenClickPropTypes = {
    action: (props: any) => any;
    id: string;
}

const HiddenClick: FC<HiddenClickPropTypes> = (props) => {
    const { action, id } = props;
    
    return (
        <span onClick={action} id={id} />
    );
};

export default HiddenClick;